export const LOAD_SETTINGS = `settings/LOAD`
export const SETTINGS_LOADED = `settings/LOADED`
